import React, { useState, useEffect } from "react";
import { Card, CardHeader, CardTitle, CardBody } from "reactstrap";

import api from "../../../../../services/api";
import useCancelableFetch from "../../../../../hooks/useCancelableFetch";
import ChartAreaOneLine from "../../../../../components/ChartAreaOneLine";
import { useCompanies } from "../../../../../hooks/companies"; // Importa o hook useCompanies

export default function ChartFretePorKg({
  deferLoad = false,
  onRegisterFetch,
}) {
  const { empresa, transportadora, arrayParams } = useCompanies(); // Obtém as seleções atuais de empresa e transportadora

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  async function loadCharts() {
    const controller = createController();
    try {
      setLoading(true);

      const params = {};

      if (arrayParams.embarcadores) {
        params.embarcadores = arrayParams.embarcadores;
      }

      if (arrayParams.transportadoras) {
        params.transportadoras = arrayParams.transportadoras;
      }

      const response = await api.get("/dashboard/custo/frete-por-kg", {
        params,
        signal: controller.signal,
      });

      if (response.status === 200) {
        setData(response.data);
      }
    } catch (error) {
      if (error && error.code === "ERR_CANCELED") {
        // aborted
      } else {
        console.error("Erro ao carregar dados:", error);
      }
    } finally {
      setLoading(false);
    }
  }

  const { createController } = useCancelableFetch(30000);

  useEffect(() => {
    if (onRegisterFetch) {
      onRegisterFetch(loadCharts);
    }

    if (!deferLoad) {
      if (empresa) loadCharts(); // Carrega os gráficos quando empresa ou transportadora mudar
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [empresa, transportadora]); // Adiciona empresa e transportadora como dependências

  return (
    <Card
      style={{ boxShadow: "0px 1px 20px 0px rgb(0, 0, 0)" }}
      className="card-chart"
    >
      <CardHeader>
        <h4>Frete médio por KG</h4>
        <CardTitle>Últimos 6 meses do custo de frete por KG</CardTitle>
      </CardHeader>
      <CardBody>
        <ChartAreaOneLine
          data={data}
          grid="rgba(255,214,0, 0.1)"
          lineColor="#ffd600"
          dataKey="valor"
          name="valor de frete"
          measure="R$"
          yAxisWidth={60}
          loading={loading}
          idLinha="freteKg"
        />
      </CardBody>
    </Card>
  );
}
